export default function validateLeitwegID(data: string): boolean {
  if (typeof data !== 'string') return false;
  const id = data.replace(/ /g, '');

  // Match Leitweg-ID structure: grobadressierung, optional feinadressierung, and pruefziffer
  const regex = /^(\d{2,12})(?:-([A-Z0-9]{1,30}))?-([0-9]{2})$/i;
  const match = id.match(regex);

  if (!match) return false; // Invalid format

  const [, grobadressierung, feinadressierung, pruefziffer] = match;

  let numericString = grobadressierung;

  // Convert Feinadressierung (if exists) from letters (A-Z) to numbers (A=10, ..., Z=35)
  if (feinadressierung) {
    numericString += feinadressierung
      .toUpperCase()
      .split('')
      .map((char) => {
        if (char >= '0' && char <= '9') return char; // Keep numbers
        return (char.charCodeAt(0) - 55).toString(); // Convert A-Z to 10-35
      })
      .join('');
  }

  // Append "00" (placeholder for Prüfziffer)
  const checksumBase = numericString + '00';

  try {
    const computedChecksum = 98 - Number(BigInt(checksumBase) % BigInt(97)); // checksum calculation

    // Valid if the Prüfziffer matches the computed checksum
    return Number(pruefziffer) === computedChecksum;
  } catch (error) {
    // BigInt might not be supported, return true and backend will validate anyway
    console.error('Error validating Leitweg ID:', error);
    return true;
  }
}
